module.exports = __webpack_public_path__ + "static/media/17_tn.c88d9c44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/17_tn.jpg
// module id = 447
// module chunks = 0